import { render, staticRenderFns } from "./DepartmentChairEditor.vue?vue&type=template&id=3b2520b4&"
import script from "./DepartmentChairEditor.vue?vue&type=script&lang=js&"
export * from "./DepartmentChairEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports